'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RadioGroup = require('@cimpress/react-components/lib/RadioGroup');

var _RadioGroup2 = _interopRequireDefault(_RadioGroup);

var _Radio = require('@cimpress/react-components/lib/Radio');

var _Radio2 = _interopRequireDefault(_Radio);

var _MerchantSelect = require('./MerchantSelect');

var _MerchantSelect2 = _interopRequireDefault(_MerchantSelect);

var _reactCimpressFulfillersComponents = require('react-cimpress-fulfillers-components');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ManyTenantsSelect = function (_React$Component) {
  _inherits(ManyTenantsSelect, _React$Component);

  function ManyTenantsSelect(props) {
    _classCallCheck(this, ManyTenantsSelect);

    var _this = _possibleConstructorReturn(this, (ManyTenantsSelect.__proto__ || Object.getPrototypeOf(ManyTenantsSelect)).call(this, props));

    _this.state = {
      resourceType: props.resourceType || 'merchant',
      selectedFulfiller: null
    };
    _this.onSelectType = _this.onSelectType.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  _createClass(ManyTenantsSelect, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.trigger();
    }
  }, {
    key: 'onChange',
    value: function onChange(tenant) {
      if (this.props.onChange) {
        this.props.onChange({
          type: this.state.resourceType,
          tenant: tenant
        });
      }
    }
  }, {
    key: 'trigger',
    value: function trigger() {
      var _props = this.props,
          merchants = _props.merchants,
          selectedMerchant = _props.selectedMerchant;
      var _state = this.state,
          resourceType = _state.resourceType,
          selectedFulfiller = _state.selectedFulfiller;
      var actualMerchant = merchants.find(function (m) {
        return m.merchantId === selectedMerchant;
      });

      if (resourceType === 'merchant' && actualMerchant) {
        this.onChange(actualMerchant);
      } else if (resourceType === 'fulfiller' && this.state.selectedFulfiller) {
        this.onChange(selectedFulfiller);
      }
    }
  }, {
    key: 'onSelectType',
    value: function onSelectType(e, resourceType) {
      var _this2 = this;

      this.setState({
        resourceType: resourceType
      }, function () {
        return _this2.trigger();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var resourceType = this.state.resourceType;
      var _props2 = this.props,
          selectedMerchant = _props2.selectedMerchant,
          merchants = _props2.merchants,
          fulfillers = _props2.fulfillers,
          authToken = _props2.authToken;
      return _react2.default.createElement('div', null, merchants.length && fulfillers.length ? _react2.default.createElement(_RadioGroup2.default, {
        inline: true,
        name: 'Tenant type',
        onChange: this.onSelectType,
        defaultSelected: resourceType
      }, _react2.default.createElement(_Radio2.default, {
        value: 'merchant',
        label: 'Merchants'
      }), _react2.default.createElement(_Radio2.default, {
        value: 'fulfiller',
        label: 'Fulfillers'
      })) : _react2.default.createElement('h3', null, resourceType === 'merchant' ? 'Merchants' : 'Fulfillers'), _react2.default.createElement('div', {
        style: resourceType !== 'merchant' ? {
          display: 'none'
        } : {}
      }, _react2.default.createElement(_MerchantSelect2.default, {
        merchants: merchants,
        selectedMerchant: selectedMerchant,
        onChange: this.onChange
      })), _react2.default.createElement('div', {
        style: resourceType !== 'fulfiller' ? {
          display: 'none'
        } : {}
      }, _react2.default.createElement(_reactCimpressFulfillersComponents.FulfillerSelect, {
        accessToken: authToken,
        fulfillers: fulfillers,
        onChange: function onChange(selectedFulfiller) {
          _this3.setState({
            selectedFulfiller: selectedFulfiller
          });

          if (resourceType === 'fulfiller') {
            _this3.onChange(selectedFulfiller);
          }
        }
      })));
    }
  }]);

  return ManyTenantsSelect;
}(_react2.default.Component);

ManyTenantsSelect.propTypes = {
  authToken: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  selectedMerchant: _propTypes2.default.string,
  merchants: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    merchantId: _propTypes2.default.string.isRequired,
    displayName: _propTypes2.default.string.isRequired
  })).isRequired,
  fulfillers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    fulfillerId: _propTypes2.default.string.isRequired,
    internalFulfillerId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    name: _propTypes2.default.string.isRequired,
    archived: _propTypes2.default.bool
  })).isRequired
};
exports.default = ManyTenantsSelect;